import type { AppLocale } from "@airange/shared/i18n-airange-admin-runtime";
import type { ConfigProviderProps } from "antd";

export async function loadAntdLocale(
  locale: AppLocale,
): Promise<NonNullable<ConfigProviderProps["locale"]>> {
  switch (locale) {
    case "en":
      return (await import("antd/locale/en_US")).default;
    case "ja":
      return (await import("antd/locale/ja_JP")).default;
    case "zh-CN":
      return (await import("antd/locale/zh_CN")).default;
  }
}
